import React from 'react';
import './LoadingSpinner.css';

function LoadingSpinner({ size = 'md', text = 'Loading...' }) {
  return (
    <div className="loading-container">
      <div className={`loading-spinner loading-spinner-${size}`}>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
      </div>
      {text && <p className="loading-text">{text}</p>}
    </div>
  );
}

export default LoadingSpinner;

